/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getProjectIdFromSpaState = (projectKey: string): number | undefined => {
	return globalThis?.window?.SPA_STATE?.PROJECT_CONTEXT?.[projectKey]?.data?.projectId;
};
